<i18n lang='yml' src='./i18n/ProgressBar.yml'></i18n>

<template>
  <div class="progress-container">
    <div class="progress">
      <div :class="`progress-bar bg-${type}`" role="progressbar" :style="getProgressStyle()" :aria-valuenow="percentage_value" aria-valuemin="0" :aria-valuemax="max_value">
      </div>
    </div>
    <p><span class="progress-value">{{approved}} {{ $t('of') }} {{total}} </span> ({{percentage_value}}%) <span v-html="$t(`${progress_message}`)"></span> </p>
  </div>
</template>
<script>
export default {
   props: {
    percentage_value: {type: Number},
    approved: {type: Number},
    total: {type: Number},
    type: {type: String},
    progress_message: {type: String},
    max_value: {
      type: Number,
      default: 100
    }
  },

  methods: {
    getProgressStyle: function () {
      return `width: ${this.percentage_value}%`
    }
  }
};
</script>

